export const makeAllButCurrentSlideInert = (swiperInstance) => {
    const currentSlideEl = swiperInstance.slides[swiperInstance.activeIndex];
    // using "inert" prop to ignore not active slides (and internal links) for accessibility
    // documentation here: https://caniuse.com/?search=inert

    // TODO: Be aware that if slidesPerView > 1 currentSlideEl is not correct
    //  use this function ONLY when slidesPerView = 1

    swiperInstance.slides.forEach((slide, index) => {
        if (slide !== currentSlideEl) {
            slide.setAttribute("inert", "");
        } else {
            slide.removeAttribute("inert");
        }
    });
};